import { Injectable, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RouteReuseStrategy } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
var StoreActionType;
(function (StoreActionType) {
    StoreActionType[StoreActionType["Set"] = 0] = "Set";
    StoreActionType[StoreActionType["Delete"] = 1] = "Delete";
    StoreActionType[StoreActionType["Clear"] = 2] = "Clear";
})(StoreActionType || (StoreActionType = {}));
class NgCacheRouteReuseStoreService {
    constructor() {
        this.detachedRouteHandles = new Map();
        this.action$ = new Subject();
    }
    static getInstance() {
        if (!NgCacheRouteReuseStoreService.instance) {
            const instance = new NgCacheRouteReuseStoreService();
            NgCacheRouteReuseStoreService.instance = instance;
        }
        return NgCacheRouteReuseStoreService.instance;
    }
    dispatch(type, component = null) {
        this.action$.next({ type, component });
    }
    on(type, component) {
        return this.action$.pipe(filter((action) => action.type === type), filter((action) => action.component === component), map((action) => action.component));
    }
    set(component, handle, { emitEvent = true } = {}) {
        this.detachedRouteHandles.set(component, handle);
        if (emitEvent) {
            this.dispatch(StoreActionType.Set, component);
        }
    }
    get(component) {
        return this.detachedRouteHandles.get(component);
    }
    has(component) {
        return this.detachedRouteHandles.has(component);
    }
    delete(component, { emitEvent = true } = {}) {
        const deleted = this.detachedRouteHandles.delete(component);
        if (emitEvent && deleted) {
            this.dispatch(StoreActionType.Delete, component);
        }
        return deleted;
    }
    clear({ emitEvent = true } = {}) {
        this.detachedRouteHandles.clear();
        if (emitEvent) {
            this.dispatch(StoreActionType.Clear);
        }
    }
}
NgCacheRouteReuseStoreService.ɵfac = function NgCacheRouteReuseStoreService_Factory(t) { return new (t || NgCacheRouteReuseStoreService)(); };
NgCacheRouteReuseStoreService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgCacheRouteReuseStoreService, factory: NgCacheRouteReuseStoreService.ɵfac });
NgCacheRouteReuseStoreService.instance = null;
NgCacheRouteReuseStoreService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgCacheRouteReuseStoreService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Provides access to reuse route's component attach/detach hooks
 * and detached routes store
 */
class NgCacheRouteReuseService {
    constructor(storeService) {
        this.storeService = storeService;
    }
    static getInstance() {
        if (!NgCacheRouteReuseService.instance) {
            const storeService = NgCacheRouteReuseStoreService.getInstance();
            const instance = new NgCacheRouteReuseService(storeService);
            NgCacheRouteReuseService.instance = instance;
        }
        return NgCacheRouteReuseService.instance;
    }
    /**
     * `Attach` component lifecycle hook.
     *
     * Triggers on component reattach - re-navigate on reuse route.
     */
    onAttach(component) {
        return this.storeService.on(StoreActionType.Delete, component);
    }
    /**
     * `Detach` component lifecycle hook.
     *
     * Triggers on component detach - navigate from reuse route.
     */
    onDetach(component) {
        return this.storeService.on(StoreActionType.Set, component);
    }
    /**
     * Check whether component is attached
     */
    isAttached(component) {
        return !this.storeService.has(component);
    }
    /**
     * Check whether component is detached
     */
    isDetached(component) {
        return this.storeService.has(component);
    }
    /**
     * Delete a reuse route's component from cache
     */
    delete(component) {
        return this.storeService.delete(component, { emitEvent: false });
    }
    /**
     * Clear the reuse route components cache
     */
    clear() {
        return this.storeService.clear();
    }
}
NgCacheRouteReuseService.ɵfac = function NgCacheRouteReuseService_Factory(t) { return new (t || NgCacheRouteReuseService)(ɵngcc0.ɵɵinject(NgCacheRouteReuseStoreService)); };
NgCacheRouteReuseService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgCacheRouteReuseService, factory: NgCacheRouteReuseService.ɵfac });
NgCacheRouteReuseService.instance = null;
NgCacheRouteReuseService.ctorParameters = () => [
    { type: NgCacheRouteReuseStoreService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgCacheRouteReuseService, [{
        type: Injectable
    }], function () { return [{ type: NgCacheRouteReuseStoreService }]; }, null); })();

/**
 * Decorator variant of `onAttach` reuse route's component lifecycle hook
 * @deprecated from 0.0.7, may be removed in 0.0.8, use `NgCacheRouteReuseService` instead
 */
function onAttach() {
    // tslint:disable-next-line: only-arrow-functions
    return function (target, propertyKey) {
        const service = NgCacheRouteReuseService.getInstance();
        const component = target.constructor;
        service.onAttach(component).subscribe(() => target[propertyKey]());
    };
}
/**
 * Decorator variant of `onAttach` reuse route's component lifecycle hook
 * @deprecated from 0.0.7, may be removed in 0.0.8, use `NgCacheRouteReuseService` instead
 */
function onDetach() {
    // tslint:disable-next-line: only-arrow-functions
    return function (target, propertyKey) {
        const service = NgCacheRouteReuseService.getInstance();
        const component = target.constructor;
        service.onDetach(component).subscribe(() => target[propertyKey]());
    };
}

class NgCacheRouteReuseStrategy {
    constructor(storeService) {
        this.storeService = storeService;
    }
    shouldBeReused(route) {
        return !!route.data.reuse;
    }
    shouldDetach(route) {
        return this.shouldBeReused(route);
    }
    store(route, handle) {
        handle
            ? this.storeService.set(route.component, handle)
            : this.storeService.delete(route.component);
    }
    shouldAttach(route) {
        return this.shouldBeReused(route)
            ? this.storeService.has(route.component)
            : false;
    }
    retrieve(route) {
        return this.shouldBeReused(route)
            ? this.storeService.get(route.component)
            : null;
    }
    shouldReuseRoute(future, current) {
        return future.routeConfig === current.routeConfig;
    }
}
NgCacheRouteReuseStrategy.ɵfac = function NgCacheRouteReuseStrategy_Factory(t) { return new (t || NgCacheRouteReuseStrategy)(ɵngcc0.ɵɵinject(NgCacheRouteReuseStoreService)); };
NgCacheRouteReuseStrategy.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgCacheRouteReuseStrategy, factory: NgCacheRouteReuseStrategy.ɵfac });
NgCacheRouteReuseStrategy.ctorParameters = () => [
    { type: NgCacheRouteReuseStoreService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgCacheRouteReuseStrategy, [{
        type: Injectable
    }], function () { return [{ type: NgCacheRouteReuseStoreService }]; }, null); })();

const ɵ0 = NgCacheRouteReuseStoreService.getInstance, ɵ1 = NgCacheRouteReuseService.getInstance;
class NgCacheRouteReuseModule {
}
NgCacheRouteReuseModule.ɵfac = function NgCacheRouteReuseModule_Factory(t) { return new (t || NgCacheRouteReuseModule)(); };
NgCacheRouteReuseModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgCacheRouteReuseModule });
NgCacheRouteReuseModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: NgCacheRouteReuseStoreService,
            useFactory: ɵ0
        },
        {
            provide: NgCacheRouteReuseService,
            useFactory: ɵ1
        },
        {
            provide: RouteReuseStrategy,
            useClass: NgCacheRouteReuseStrategy
        },
    ], imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgCacheRouteReuseModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                providers: [
                    {
                        provide: NgCacheRouteReuseStoreService,
                        useFactory: ɵ0
                    },
                    {
                        provide: NgCacheRouteReuseService,
                        useFactory: ɵ1
                    },
                    {
                        provide: RouteReuseStrategy,
                        useClass: NgCacheRouteReuseStrategy
                    },
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of ng-cache-route-reuse
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgCacheRouteReuseModule, NgCacheRouteReuseService, onAttach, onDetach, ɵ0, ɵ1, NgCacheRouteReuseStoreService as ɵa, NgCacheRouteReuseStrategy as ɵb };

